import { TextareaField } from "@ps-design-system/components/Textarea";

import { useIntl } from "react-intl-compat";

const DescriptionField = () => {
  const intl = useIntl();

  return (
    <TextareaField
      fullWidth
      name="description"
      label={intl.formatMessage({
        id: "hosting.listing_details.description_label",
        defaultMessage: "About the space",
      })}
      testId="listing-details-form-description-input"
    />
  );
};

export { DescriptionField };
